import { render, staticRenderFns } from "./FilmScoreDetail.vue?vue&type=template&id=6a611824&scoped=true&"
import script from "./FilmScoreDetail.vue?vue&type=script&lang=js&"
export * from "./FilmScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./FilmScoreDetail.vue?vue&type=style&index=0&id=6a611824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a611824",
  null
  
)

export default component.exports